module.exports = __webpack_public_path__ + "search-e1c42211e264c24fbf33.svg";